import { render, staticRenderFns } from "./RegistraPezziAlt.vue?vue&type=template&id=46d21e37&scoped=true&"
import script from "./RegistraPezziAlt.vue?vue&type=script&lang=js&"
export * from "./RegistraPezziAlt.vue?vue&type=script&lang=js&"
import style0 from "./RegistraPezziAlt.vue?vue&type=style&index=0&id=46d21e37&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d21e37",
  null
  
)

export default component.exports